import React, { PropsWithChildren, useContext, useEffect, useState } from 'react';
import { CheckCircle, Link as FeatherLinkIcon } from 'react-feather';
import styled from 'styled-components';
import linkedin from '../../assets/social/linkedin.svg';
import twitter from '../../assets/social/twitter.svg';
import { AlertContext, AlertType } from '../../context/alertContext';

interface Props {
  text: string;
  center?: boolean;
}

export default ({ text, center }: PropsWithChildren<Props>) => {
  const { alertMessage, setAlertMessage } = useContext(AlertContext);
  const [url, setUrl] = useState<undefined | string>(undefined);

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  const CopyLink = () => {
    if (url) {
      navigator.clipboard.writeText(url);
    }
    setAlertMessage({
      isOpen: true,
      message: 'Link copied to clipboard',
      alertType: AlertType.SUCCESS,
    });
  };

  return (
    <SocialLinks isCenter={center}>
      <div>
        <LinkButton>
          <a
            className="twitter-share-button"
            href={`https://twitter.com/intent/tweet?text=daisee%20—%20${text}%0A%0A${url}`}
            data-size="large"
            target="_blank"
            rel="noreferrer"
          >
            <LinkIcon src={twitter} width="34px" />
          </a>
        </LinkButton>
      </div>
      <div>
        <LinkButton>
          <a
            className="twitter-share-button"
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
            data-size="large"
            target="_blank"
            rel="noreferrer"
          >
            <LinkIcon src={linkedin} width="24px" />
          </a>
        </LinkButton>
      </div>
      <div role="button" onKeyDown={CopyLink} onClick={CopyLink} tabIndex={0}>
        <LinkButton>
          {alertMessage.isOpen && alertMessage.alertType === AlertType.SUCCESS ? (
            <CheckCircle width="20px" />
          ) : (
            <FeatherLinkIcon width="20px" />
          )}
        </LinkButton>
      </div>
    </SocialLinks>
  );
};

interface IconProps {
  width: string;
}

interface SocialLinksProps {
  isCenter?: boolean;
}

const SocialLinks = styled.div<SocialLinksProps>`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  width: fit-content;
  align-items: baseline;
  justify-items: center;
  margin: ${({ isCenter }) => isCenter && '0 auto'};
`;

const LinkButton = styled.button`
  outline: none;
  background: transparent;
  border: none;
  cursor: pointer;
`;

const LinkIcon = styled.img<IconProps>`
  width: ${({ width }) => width};
`;
